// src/ui/PostTranslation.jsx — "See translation" under a post in another language
// (the phone's twin is src/components/PostTranslation.tsx). Offered only when the
// words are clearly not in the reader's language (services/textLang); translated
// once per post, language and wording by the server (translateRoutes.js).
import React, { useState } from 'react';
import { offersTranslation, textKey } from '../services/textLang';
import { postJson } from '../services/vibeSocial';

const seen = new Map();
const readerLang = () => { try { return String(navigator.language || 'en').split('-')[0]; } catch { return 'en'; } };

export default function PostTranslation({ post }) {
  const lang = readerLang();
  const words = String(post?.content || '');
  const key = `${post?.id}|${lang}|${textKey(words)}`;
  const [shown, setShown] = useState(seen.get(key) || null);
  const [on, setOn] = useState(false);
  const [busy, setBusy] = useState(false);
  const [failed, setFailed] = useState(false);
  if (!post?.id || !offersTranslation(words, lang)) return null;
  const toggle = async (e) => {
    e.stopPropagation();
    if (on) { setOn(false); return; }
    if (shown) { setOn(true); return; }
    setBusy(true); setFailed(false);
    const r = await postJson('/api/vibes/translate', { postId: post.id, target: lang });
    setBusy(false);
    if (r && r.ok && r.text) { seen.set(key, r.text); setShown(r.text); setOn(true); } else setFailed(true);
  };
  return (
    <div className="vb-translate">
      {on && shown && <p className="vb-translated">{shown}</p>}
      <button className="vb-translate-btn" onClick={toggle} disabled={busy}>
        {busy ? 'Translating…' : failed ? 'Couldn’t translate — try again' : on ? 'See original' : 'See translation'}
      </button>
    </div>
  );
}
